import { ValidationTypes } from "@enums/validation-types";
import { CaptureStepTypes } from "@enums/capture-step-types";
import { ValidationResult } from "../types/common/validation-result";
import { CaptureStepValidationResults } from "../types/data/validation-results";


export const getInitialValidationResultsForCaptureStep = (
    captureStepType: CaptureStepTypes,
    livenessCheck: boolean,
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    switch (captureStepType) {
        case CaptureStepTypes.FACE:
            return getInitialFaceCaptureStepValidationsMap(livenessCheck)
        case CaptureStepTypes.DRIVER_LICENSE_FRONT:
            return getInitialDriverLicenseFrontCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        case CaptureStepTypes.DRIVER_LICENSE_BACK:
            return getInitialDriverLicenseBackCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        case CaptureStepTypes.PASSPORT:
            return getInitialPassportCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        case CaptureStepTypes.ID_CARD_FRONT:
            return getInitialIdCardFrontCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        case CaptureStepTypes.ID_CARD_BACK:
            return getInitialIdCardBackCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
        default:
            return {};
    }
};

export const getInitialValidationResult = (validationType: ValidationTypes): ValidationResult => {
    const isRequired = ![ValidationTypes.PORTRAIT_ORIENTATION_DETECTION, ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION].includes(validationType);

    return {
        type: validationType,
        isValid: false,
        inProgress: false,
        isRequired: isRequired,
        isDisabled: false,
        errorMessage: null
    };
};

export const getInitialFaceCaptureStepValidationsMap = (livenessCheck: boolean) => {
    const validationResults: CaptureStepValidationResults = {};
    validationResults[ValidationTypes.PORTRAIT_ORIENTATION_DETECTION] = getInitialValidationResult(ValidationTypes.PORTRAIT_ORIENTATION_DETECTION);

    if (livenessCheck) {
        validationResults[ValidationTypes.LIVENESS_DETECTION] = getInitialValidationResult(ValidationTypes.LIVENESS_DETECTION);
    }

    return validationResults;
};

const getGenericCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    const validationResults: CaptureStepValidationResults = {};
    validationResults[ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION] = getInitialValidationResult(ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION);
    if (useAcuantSDKDPIValdidation) {
        validationResults[ValidationTypes.GOOD_RESOLUTION_DETECTION] = getInitialValidationResult(ValidationTypes.GOOD_RESOLUTION_DETECTION);
    }
    if (useAcuantSDKGlareValidation) {
        validationResults[ValidationTypes.GLARE_DETECTION] = getInitialValidationResult(ValidationTypes.GLARE_DETECTION);
    }
    if (useAcuantSDKSharpnessValidation) {
        validationResults[ValidationTypes.SHARPNESS_DETECTION] = getInitialValidationResult(ValidationTypes.SHARPNESS_DETECTION);
    }

    return validationResults;
}

export const getInitialDriverLicenseFrontCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    return getGenericCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
};

export const getInitialDriverLicenseBackCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    return getGenericCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
};

export const getInitialPassportCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    return getGenericCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
};

export const getInitialIdCardFrontCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    return getGenericCaptureStepValidationsMap(useAcuantSDKDPIValdidation, useAcuantSDKGlareValidation, useAcuantSDKSharpnessValidation);
};

export const getInitialIdCardBackCaptureStepValidationsMap = (
    useAcuantSDKDPIValdidation: boolean,
    useAcuantSDKGlareValidation: boolean,
    useAcuantSDKSharpnessValidation: boolean
) => {
    const validationResults: CaptureStepValidationResults = {};
    validationResults[ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION] = getInitialValidationResult(ValidationTypes.LANDSCAPE_ORIENTATION_DETECTION);
    if (useAcuantSDKDPIValdidation) {
        validationResults[ValidationTypes.GOOD_RESOLUTION_DETECTION] = getInitialValidationResult(ValidationTypes.GOOD_RESOLUTION_DETECTION);
    }
    if (useAcuantSDKGlareValidation) {
        validationResults[ValidationTypes.GLARE_DETECTION] = getInitialValidationResult(ValidationTypes.GLARE_DETECTION);
    }
    if (useAcuantSDKSharpnessValidation) {
        validationResults[ValidationTypes.SHARPNESS_DETECTION] = getInitialValidationResult(ValidationTypes.SHARPNESS_DETECTION);
    }

    return validationResults;
};